module.exports = __webpack_public_path__ + "static/media/Business accounts - SD (0).0d0705c8.jpg";